import { queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';
import { getActiveWorkspaceId } from '@/stores/user.store';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  onboarding: () => [...dashboardKeys.all, 'onboarding', getActiveWorkspaceId()] as const,
  formSubmissions: () => [...dashboardKeys.all, 'form-submissions', getActiveWorkspaceId()] as const,
  inspectionTrend: () => [...dashboardKeys.all, 'inspection-trend', getActiveWorkspaceId()] as const,
  inspectionsToday: () => [...dashboardKeys.all, 'inspections-today', getActiveWorkspaceId()] as const,
  issuesByAsset: () => [...dashboardKeys.all, 'issues-by-asset', getActiveWorkspaceId()] as const,
  issuesSummary: () => [...dashboardKeys.all, 'issues-summary', getActiveWorkspaceId()] as const,
  recentIssues: () => [...dashboardKeys.all, 'recent-issues', getActiveWorkspaceId()] as const,
};

// These tiles are cosmetic and workspace-scoped: a 403 means the api-v2 afterResponse hook is already
// signing the user out, so retrying just fires redundant requests. Don't retry any of them.
const NO_RETRY = { retry: false } as const;

export const getDashboardOnboardingQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.onboarding(),
    queryFn: async () => (await ApiService.GetDashboardOnboarding()).json(),
    ...NO_RETRY,
  });

export const getDashboardFormSubmissionsQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.formSubmissions(),
    queryFn: async () => (await ApiService.GetDashboardFormSubmissions()).json(),
    ...NO_RETRY,
  });

export const getDashboardInspectionTrendQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.inspectionTrend(),
    queryFn: async () => (await ApiService.GetDashboardInspectionTrend()).json(),
    ...NO_RETRY,
  });

export const getDashboardInspectionsTodayQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.inspectionsToday(),
    queryFn: async () => (await ApiService.GetDashboardInspectionsToday()).json(),
    ...NO_RETRY,
  });

export const getDashboardIssuesByAssetQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.issuesByAsset(),
    queryFn: async () => (await ApiService.GetDashboardIssuesByAsset()).json(),
    ...NO_RETRY,
  });

export const getDashboardIssuesSummaryQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.issuesSummary(),
    queryFn: async () => (await ApiService.GetDashboardIssuesSummary()).json(),
    ...NO_RETRY,
  });

export const getDashboardRecentIssuesQueryOptions = () =>
  queryOptions({
    queryKey: dashboardKeys.recentIssues(),
    queryFn: async () => (await ApiService.GetDashboardRecentIssues()).json(),
    ...NO_RETRY,
  });
